// src/AdminDashboard.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';

import DashboardIcon        from '@mui/icons-material/Dashboard';
import PeopleIcon           from '@mui/icons-material/People';
import MessageIcon          from '@mui/icons-material/Message';
import HistoryIcon          from '@mui/icons-material/History';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import AssessmentIcon       from '@mui/icons-material/Assessment';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

import MetricsDashboard      from './pages/admin/MetricsDashboard';
import PartnerManagementPage from './pages/admin/PartnerManagementPage';
import AdminMessagesPage     from './pages/admin/AdminMessagesPage';
import AdminLogsPage         from './pages/admin/AdminLogsPage';
import ApprovalRequestsPage  from './pages/admin/ApprovalRequestsPage';
import ReportsPage           from './pages/admin/ReportsPage';
import UserManagementPage    from './pages/admin/UserManagementPage';

const adminMenuItems = [
    { text: 'Métricas',           path: '/admin/dashboard',  icon: <DashboardIcon /> },
    { text: 'Parceiros',          path: '/admin/parceiros',  icon: <PeopleIcon /> },
    { text: 'Solicitações',       path: '/admin/solicitacoes', icon: <PlaylistAddCheckIcon /> },
    { text: 'Mensagens',          path: '/admin/mensagens',  icon: <MessageIcon /> },
    { text: 'Relatórios',         path: '/admin/relatorios', icon: <AssessmentIcon /> },
    { text: 'Gerenciar Cadastros', path: '/admin/cadastros', icon: <SupervisorAccountIcon /> },
    { text: 'Logs',               path: '/admin/logs',       icon: <HistoryIcon /> },
];

function AdminDashboard({ userProfile, onFirstAccessComplete }) {
    return (
        <DashboardLayout
            menuItems={adminMenuItems}
            pageTitle="Painel do Administrador"
            userProfile={userProfile}
            onFirstAccessComplete={onFirstAccessComplete}
        >
            <Routes>
                <Route path="/"           element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard"   element={<MetricsDashboard />} />
                <Route path="parceiros"   element={<PartnerManagementPage />} />
                <Route path="solicitacoes" element={<ApprovalRequestsPage />} />
                <Route path="mensagens"   element={<AdminMessagesPage />} />
                <Route path="relatorios"  element={<ReportsPage />} />
                <Route path="cadastros"   element={<UserManagementPage />} />
                <Route path="logs"        element={<AdminLogsPage />} />
            </Routes>
        </DashboardLayout>
    );
}

export default AdminDashboard;
